// libraries
import React from 'react'

// components
import Section from '/react4xp/components/Section'
import SuccessStoriesCard from '/react4xp/components/SuccessStoriesCard'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils'

interface ListSuccessStoriesProps {
    title?: string
    featured?: {
        href: {
            url: string
            isExternal?: boolean
        }
        img?: {
            src: string
            srcSmall?: string
            alt?: string
        }
        subtitle?: string
        title: string
    }
    stories: Array<{
        href: {
            url: string
            isExternal?: boolean
        }
        img?: {
            src: string
            srcSmall?: string
            alt?: string
        }
        subtitle?: string
        title: string
    }>
    viewAll?: {
        text: string
        url: string
        isExternal?: boolean
    }
}

export default function ListSuccessStories({
    title,
    featured,
    stories,
    viewAll
}: ListSuccessStoriesProps) {
    return (
        <Section
            bgColor='bg-primary'
            textColor='text-light'
            className='list-success-stories'
        >
            <div className='grid-container'>

                <div className='list-success-stories__wrapper'>

                    {isNonWhitespaceString(title) && (
                        <h2 className='list-success-stories__title'>
                            {title}
                        </h2>    
                    )}

                    {featured && (
                        <SuccessStoriesCard
                            featured={true}
                            href={{
                                url: featured?.href?.url,
                                isExternal: featured?.href?.isExternal
                            }}
                            img={{
                                src: featured?.img?.src,
                                srcSmall: featured?.img?.srcSmall,
                                alt: featured?.img?.alt
                            }}
                            subtitle={featured?.subtitle}
                            title={featured?.title}
                        />
                    )}

                    {stories && stories.length >= 1 ? (
                        <>
                            <div className='list-success-stories__blocks'>
                                {stories.map((item, i) => (
                                    <SuccessStoriesCard
                                        key={i}
                                        featured={false}
                                        href={{
                                            url: item.href?.url,
                                            isExternal: item.href?.isExternal
                                        }}
                                        img={{
                                            src: item.img?.src,
                                            alt: item.img?.alt
                                        }}
                                        subtitle={item.subtitle}
                                        title={item.title}
                                    />
                                ))}
                            </div>

                            {viewAll?.url && (
                                <div className='list-success-stories__view-all'>
                                    <a
                                        href={viewAll.url}
                                        target={viewAll.isExternal ? '_blank' : undefined}
                                    >
                                        {viewAll.text} <svg width='14' height='12' fill='currentColor' viewBox='0 0 14 12' xmlns='http://www.w3.org/2000/svg'><path d='M8.00005 0.51001L13.49 5.99996L8.00005 11.4899L7.0101 10.5L10.8101 6.69996H0.800049V5.29996H10.8101L7.0101 1.49996L8.00005 0.51001Z'/></svg>
                                    </a>
                                </div>
                            )}

                        </>
                    ) : null }

                </div>
            </div>
        </Section>
    )
}

